import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const SelectClassName = `${CLASS_NAME_PREFIX}-select`;
export const SelectDropdownClassName = `${SelectClassName}__dropdown`;
export const SelectDropdownItemClassName = `${SelectDropdownClassName}-item`;
